import { Text } from '@vinted/web-ui'

export type Props = {
  discountHint?: string
}

const BundleHeaderSubtitle = ({ discountHint }: Props) => (
  <Text
    as="h3"
    type="subtitle"
    format
    text={discountHint}
    theme="success"
    width="parent"
    alignment="center"
    testId="bundle-header-title"
  />
)

export default BundleHeaderSubtitle
